import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var grey = {
  grey: '#484848',
  grey900: '#222222',
  grey800: '#484848',
  grey700: '#676767',
  grey600: '#7C7C7C',
  grey500: '#A5A5A5',
  grey400: '#C4C4C4',
  grey300: '#E6E6E6',
  grey200: '#F1F1F1',
  grey100: '#F6F6F6',
  grey50: '#FFFFFF',
  black: '#262626',
  white: '#FFFFFF'
};
var primary = {
  primary: '#00AA46',
  primary900: '#004628',
  primary800: '#007841',
  primary700: '#008932',
  primary600: '#009B3E',
  primary500: '#00AA46',
  primary400: '#42B763',
  primary300: '#68C37E',
  primary200: '#95D4A3',
  primary100: '#BFE5C7',
  primary50: '#E4F5E8'
};
var secondary = {
  secondary: '#00AA46',
  secondary900: '#004628',
  secondary800: '#007841',
  secondary700: '#008932',
  secondary600: '#009B3E',
  secondary500: '#00AA46',
  secondary400: '#45DC77',
  secondary300: '#70F682',
  secondary200: '#91FA9B',
  secondary100: '#BFE5C7',
  secondary50: '#E4F5E8'
};
var info = {
  info: '#C1CDE1',
  info900: '#00307F',
  info800: '#004193',
  info700: '#004B9E',
  info600: '#004B9E',
  info500: '#005CB4',
  info400: '#3974BC',
  info300: '#678DC4',
  info200: '#96ADD1',
  info100: '#C1CDE1',
  info50: '#E7EBF2'
};
var success = {
  success: '#BFE5C7',
  success900: '#00591E',
  success800: '#007830',
  success700: '#0C893B',
  success600: '#1B9B46',
  success500: '#24A94F',
  success400: '#4CB669',
  success300: '#6DC382',
  success200: '#97D4A5',
  success100: '#BFE5C7',
  success50: '#E4F5E8'
};
var error = {
  error: '#F7E6E6',
  error900: '#AD0111',
  error800: '#C6161A',
  error700: '#D51F1F',
  error600: '#E22624',
  error500: '#EC2C27',
  error400: '#EF5343',
  error300: '#F07463',
  error200: '#F49C8E',
  error100: '#F8C4BA',
  error50: '#F7E6E6'
};
var warning = {
  warning: '#efd9b0',
  warning900: '#b54e00',
  warning800: '#c06300',
  warning700: '#c67103',
  warning600: '#cc7e08',
  warning500: '#d0890d',
  warning400: '#d59829',
  warning300: '#dba94c',
  warning200: '#e5c17d',
  warning100: '#efd9b0',
  warning50: '#f8f0df'
};
var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, grey), primary), secondary), info), success), error), warning);

export { colors, error, grey, info, primary, secondary, success, warning };
//# sourceMappingURL=colors.js.map
